import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Tooltip from "~/js/common/tooltip";

export default class Inquiry {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      }
    });

    this.header = new Header();
    this.footer = new Footer();
    this.tooltip = new Tooltip();

    const checkbox1 = document.querySelector(".f-checkbox1");
    const submitButton = document.querySelector(".f-submit");

    if (checkbox1 && submitButton) {
      checkbox1.addEventListener("change", (event) => {
        if (checkbox1.checked) {
          submitButton.disabled = false;
        } else {
          submitButton.disabled = true;
        }
      });
    }

    store.dispatch("init");
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Inquiry();
});
